import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useApiErrorDialog } from '@/shared/model/apiErrorDialog';
import classes from './ApiErrorDialog.module.scss';

/** Показывает читаемое сообщение об ошибке запроса. */
export const ApiErrorDialog = () => {
    const message = useApiErrorDialog((state) => state.message);
    const pendingCount = useApiErrorDialog((state) => state.pending.length);
    const dismiss = useApiErrorDialog((state) => state.dismiss);

    return (
        <Dialog
            visible={message !== null}
            onHide={dismiss}
            modal
            draggable={false}
            resizable={false}
            header="Не удалось выполнить действие"
            className={classes.dialog}
            footer={<Button
                type="button"
                label="Понятно"
                onClick={dismiss}
                autoFocus
            />}
        >
            <div className={classes.content}>
                <span
                    className={`pi pi-exclamation-circle ${classes.icon}`}
                    aria-hidden="true"
                />
                <div className={classes.body}>
                    <p className={classes.message}>{message}</p>
                    {pendingCount > 0 && (
                        <p className={classes.pending}>Ещё сообщений: {pendingCount}</p>
                    )}
                </div>
            </div>
        </Dialog>
    );
};
